export const currencyFormatter = (value, defaultValue = '', suffix = '') => {
  if (!value || typeof value !== 'number') return defaultValue;
  return `$${value.toLocaleString('en-US')}${suffix ? ` ${suffix}` : ''}`;
};
